import { render, staticRenderFns } from "./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=template&id=0cae3db2&"
import script from "./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=script&lang=js&"
export * from "./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=script&lang=js&"
import style0 from "./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=style&index=0&lang=scss&module=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=style&index=0&lang=scss&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=style&index=0&lang=scss&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js").rerender("0cae3db2")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cae3db2')) {
      api.createRecord('0cae3db2', component.options)
    } else {
      api.reload('0cae3db2', component.options)
    }
    module.hot.accept("./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=template&id=0cae3db2&", function () {
      api.rerender('0cae3db2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/MinimalHeader/NsMinimalHeaderProfileDropdownMobile.vue"
export default component.exports